import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import scoreboardImg3 from '../../../../assets/score3.png';
import scoreboardImg6 from '../../../../assets/score6.png';
import scoreboardImg8 from '../../../../assets/score8-details.png';
import scoreboardImg8Simplified from '../../../../assets/score8-details-simplified.png';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import axios from 'axios';
import SpinnerLoaderBlack from '../../../../Component/SpinnerLoaderBlack/SpinnerLoaderBlack';

const Scoreboard = ({ selectedEvents }) => {
  const [color1, setColor1] = useState('#A46E40'); // Team 1 Score Board Color
  const [color2, setColor2] = useState('#ffffff'); // Team 1 Score Color
  const [color3, setColor3] = useState('#e7ded3'); // Team 2 Score Board Color
  const [color4, setColor4] = useState('#00000'); // Team 2 Score Color
  const [options, setOptions] = useState({});
  const [activeGroupCode, setActiveGroupCode] = useState(null); // State to track active group for color panel
  const [eventStatuses, setEventStatuses] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const formattedGroupCode = typeof activeGroupCode === 'string' ? activeGroupCode.replace('GC', '') : '';

  // Get the group code and event options stored in localStorage
  const selectedGroupCodes = JSON.parse(localStorage.getItem('selectedGroupCodes'));
  const selectedEventsOptions = JSON.parse(localStorage.getItem('selectedEventsOptions'));
  useEffect(() => {
    if (typeof selectedEventsOptions === 'object' && selectedEventsOptions !== null && Object.keys(selectedEventsOptions).length > 0) {
      setOptions(selectedEventsOptions);
    }
  }, [typeof selectedEventsOptions === 'object' && selectedEventsOptions !== null, selectedEvents]);

  const scoreboardData = [
    {
      _id: '01',
      design: "OLD DESIGN",
      title: 'Web overlay',
      image: scoreboardImg3,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/3/?id=`,
      scoreBoardColorChange: true,
    },
    {
      _id: '02',
      design: "OLD DESIGN (SIMPLIFIED)",
      title: 'Web overlay',
      image: scoreboardImg6,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/6/?id=`,
      scoreBoardColorChange: true,
    },
    {
      _id: '03',
      design: "NEW DESIGN",
      title: 'Web overlay',
      image: scoreboardImg8,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/8/?detail=true&id=`,
      scoreBoardColorChange: true,
    },
    {
      _id: '04',
      design: "NEW DESIGN (SIMPLIFIED)",
      title: 'Web overlay',
      image: scoreboardImg8Simplified,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/8/?detail=false&id=`,
      scoreBoardColorChange: true,
    }
  ];

  const handleCopyClick = async (link, id, eg) => {
    try {
      const fullUrl = `${link}${id}${eg ? `&eg=${eg}` : ''}`;
      await navigator.clipboard.writeText(fullUrl);
      toast.success('Copied to clipboard!');
    } catch (error) {
      toast.error('Failed to copy to clipboard');
    }
  };

  const selectEvent = useSelector((state) => state?.settingReducer?.selectEvent);




  const handleColorChange = (color, index) => {
    switch (index) {
      case 1:
        setColor1(color.hex);
        break;
      case 2:
        setColor2(color.hex);
        break;
      case 3:
        setColor3(color.hex);
        break;
      case 4:
        setColor4(color.hex);
        break;
      default:
        break;
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
     

      const data = new FormData();
      if (!formattedGroupCode) {
        toast.error('No group selected. Please open a group panel first.');
        return;
      }
      setIsSaving(true);
      data.append('eg_id', formattedGroupCode);
      data.append('color1', color1);
      data.append('color2', color2);
      data.append('color3', color3);
      data.append('color4', color4);

      const response = await axios.post(`${process.env.REACT_APP_API_ROOT}` + '/api/set_color/',
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
          },
        }
      );

      if (response) {
        toast.success('Colors saved successfully!');
        setActiveGroupCode(null);
      }
    } catch (error) {

      toast.error('Failed to save colors');
    }
    finally {
      setIsSaving(false);
    }
  };

  const handleReset = () => {
    setColor1('#A46E40');
    setColor2('#ffffff');
    setColor3('#e7ded3');
    setColor4('#00000');
  };

  const handleCancel = () => {
    handleReset();
    setActiveGroupCode(null);
  };

  const toggleColorPanel = (groupCode) => {
    setActiveGroupCode(activeGroupCode === groupCode ? null : groupCode);
  };
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        const eventCodes = Object.values(selectedEventsOptions).flat().map(event => event.eventCode);

        const statusResponses = await Promise.all(
          eventCodes.map(eventCode =>
            axios.get(`${process.env.REACT_APP_API_ROOT}/api/get_event/${eventCode}/`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
          )
        );

        const statuses = statusResponses.map(response => ({
          event_code: response.data.event_code.replace('EC', ''), // Removes "EC" from the event_code
          status: response.data.game_status.status,
        }));


        setEventStatuses(statuses);
      } catch (error) {
        console.error('Error fetching event statuses:', error);
      }
    };

    if (selectedEventsOptions && Object.keys(selectedEventsOptions).length > 0) {
      fetchStatuses();
    }
  }, [selectEvent]);

  const renderEventButton = (groupCode, event, matchingStatus) => (
    <button
      onClick={() => toggleColorPanel(groupCode)}
      className={`bg-primary text-white border border-primary font-bebas px-2 disabled:text-white disabled:hover:bg-primary disabled:cursor-not-allowed py-2 rounded leading-none flex justify-center items-center hover:text-primary hover:bg-white ${matchingStatus?.status !== 'n' ? 'opacity-50 cursor-not-allowed' : ''}`}
      disabled={matchingStatus?.status !== 'n'}
    >
      Score Board Color Change
    </button>
  );

  const renderEvent = (groupCode, event) => (
    <div className='flex flex-col gap-6 relative' key={event.eventCode}>
      <div className='flex justify-between items-center'>
        <h3 className='text-left font-bebas text-2xl pl-2'>
          {event.label}
        </h3>
      </div>
      {scoreboardData.map((data, i) => (
        <div key={`${event.eventCode}-${i}`} className='border-[1px] border-[#E8E8E8] rounded-md flex flex-col md:flex-row justify-between items-center'>
          <div className='border-r-[1px] border-[#E8E8E8] max-w-[675px] w-full'>
            <p className='font-bebas text-[#4A4A4A] text-2xl py-4 px-6'>
              {data.design}
            </p>
            <div className='py-4 px-6 flex flex-col gap-2 border-t-[1px] border-[#E8E8E8]'>
              <p className='font-bebas block text-[#4A4A4A] text-2xl'>
                {data.title}
              </p>
              {(() => {
                const egParam = typeof groupCode === 'string' ? groupCode.replace('GC', '') : '';
                const displayUrl = `${data.link}${event.eventCode}${egParam ? `&eg=${egParam}` : ''}`;
                return (
                  <p className='text-[#2F2B77] block font-montserrat font-medium text-base break-all'>
                    {displayUrl}
                  </p>
                );
              })()}
              <button
                onClick={() => handleCopyClick(data.link, event.eventCode, (typeof groupCode === 'string' ? groupCode.replace('GC', '') : ''))}
                className='max-w-16 w-full h-8 rounded bg-primary flex justify-center items-center text-white font-bebas'
              >
                Copy
              </button>
            </div>
          </div>
          <div className='flex justify-center items-center max-w-[480px] w-full py-[52px] md:py-0 border-t-[1px] border-[#E8E8E8] md:border-none'>
            <div className='max-w-[272px] md:max-w-[400px] w-full h-[103px] md:h-[152px] flex justify-center items-center'>
              <img className='w-full object-cover rounded-md' src={data.image} alt="scoreboardImg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <div className='relative'>
        {selectedGroupCodes && selectedGroupCodes.length && selectedGroupCodes.map((groupCode) => (
          <div key={groupCode} className='flex flex-col gap-6 relative'>
            <div className='flex justify-between items-center pt-5'>
              <h2 className=' text-left font-bebas text-2xl pl-2'>
                Group Code: {groupCode}
              </h2>

              {options?.[groupCode]?.slice(0, 1).map((event) => {
                const matchingStatus = eventStatuses.find(status => {
                  return status.event_code == event.eventCode;
                });
                return renderEventButton(groupCode, event, matchingStatus);
              })}

            </div>

            {options?.[groupCode]?.map((event) => renderEvent(groupCode, event))}

            {activeGroupCode === groupCode && (
              <div className='color-panel absolute top-0 bg-primary/20 backdrop-blur-lg p-5 rounded-xl shadow-xl'>
                {isSaving && (
                  <div className='absolute inset-0 bg-white/60 flex items-center justify-center rounded-xl z-10'>
                    <SpinnerLoaderBlack />
                  </div>
                )}
                <h3 className='font-bebas text-[#4A4A4A] text-2xl text-center pb-5'>Score Board Color Change</h3>
                <div className='flex gap-4'>
                  <div className='flex gap-4'>
                    <div>
                      <p className='text-center pb-3 font-montserrat font-medium'>Team 1 Score Board Color</p>
                      <SketchPicker color={color1} onChange={(color) => handleColorChange(color, 1)} disableAlpha={false} />
                    </div>
                    <div>
                      <p className='text-center pb-3 font-montserrat font-medium'>Team 1 Score Color</p>
                      <SketchPicker color={color2} onChange={(color) => handleColorChange(color, 2)} disableAlpha={false} />
                    </div>
                  </div>
                  <div className='flex gap-4 '>
                    <div>
                      <p className='text-center pb-3 font-montserrat font-medium'>Team 2 Score Board Color</p>
                      <SketchPicker color={color3} onChange={(color) => handleColorChange(color, 3)} disableAlpha={false} />
                    </div>
                    <div>
                      <p className='text-center pb-3 font-montserrat font-medium'>Team 2 Score Color</p>
                      <SketchPicker color={color4} onChange={(color) => handleColorChange(color, 4)} disableAlpha={false} />
                    </div>
                  </div>
                </div>
                <div className='flex gap-4 pt-10'>
                  <button onClick={handleReset} disabled={isSaving} className='bg-gray-200 px-4 py-2 flex-1 disabled:opacity-60 disabled:cursor-not-allowed'>Reset</button>
                  <button onClick={handleCancel} disabled={isSaving} className='bg-red-500 text-white px-4 py-2 flex-1 disabled:opacity-60 disabled:cursor-not-allowed'>Cancel</button>
                  <button onClick={handleSave} disabled={isSaving} className='bg-green-500 text-white px-4 py-2 flex-1 disabled:opacity-60 disabled:cursor-not-allowed'>Save</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Scoreboard;
